var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ListPanel',{attrs:{"portal":_vm.portal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }